'use client'

/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import React from 'react'
import styled from 'styled-components'
import Image from 'next/image'
import { ackodriveLogoConfig, backgroundColorConfig, textAlignmentConfig } from '@configs/ackodrivelogo.config'

const LogoContainer = styled.a<{ margin: any }>`
  margin: ${props => props.margin || '0'};
  cursor: pointer;
  flex-shrink: 0;
  line-height: 1;
  &.selected {
    pointer-events: none;
    cursor: none;
  }
`

const Logo = props => {
  const backgroundColor = backgroundColorConfig[props.white ?? false]
  const textAlignment = textAlignmentConfig[(props.white ?? false) && !props.whiteText]
  const { src, alt, ...imageProps } = ackodriveLogoConfig[backgroundColor][textAlignment]
  return (
    <LogoContainer
      margin={props.margin}
      href="/"
      className={props.logoNonClickable ? 'selected' : ''}
      data-testid="ackodrive-logo">
      <Image src={src} alt={alt} {...imageProps} />
    </LogoContainer>
  )
}

export default Logo
